<template>
  <div class="city-list">
    <div class="header">
      <div class="left" @click="onHomeClick">
        <icon :size="19">tubiaoguifan2</icon>
      </div>
      <div class="title">当前城市 - {{ gpsCity.name }}</div>
    </div>
    <div class="search-city-input">
      <div class="input-wrap" :class="{ onFocus: isFocus }">
        <Icon size="20" class="search-icon">sousuo-sousuofangdajing</Icon>
        <input
          type="text"
          class="search-input"
          placeholder="输入城市名或拼音"
          @focus="showCancelBtn"
          v-model="searchInput"
          ref="searchInput"
          @input="searchCity"
        />
        <div class="clean-icon" @click="cleanInput">
          <Icon size="20" v-show="showCleanBtn">chongzhi-qingchu</Icon>
        </div>
      </div>
      <div v-if="isFocus" class="cancel-btn" @click="hideCancelBtn">取消</div>
    </div>

    <mt-index-list class="city-index">
      <div class="recommend-city">
        <div class="gprs-city">
          <div class="city-index-title">GPS定位你所在城市</div>
          <ul class="city-index-detail cleanfix">
            <li class="city-item-detail city-item-detail-gprs">
              <div v-if="gpsCity.name" class="city-item-text" @click.passive="onCityClick(gpsCity.cityId, gpsCity.name)">
                {{ gpsCity.name }}
              </div>
              <div v-else class="city-item-text">定位失败</div>
            </li>
          </ul>
        </div>
        <div class="hot-city">
          <div class="city-index-title">热门城市</div>
          <ul class="city-index-detail cleanfix">
            <li class="city-item-detail" v-for="city in hotCities" :key="city.cityId" @click.passive="onCityClick(city.cityId, city.name)">
              <div class="city-item-text">{{ city.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <mt-index-section v-for="(item, key) of cityList" :key="key" :index="key" class="city-index-section">
        <li v-for="city in item" :key="city.cityId" :cityId="city.cityId" :pinyin="city.pinyin" class="city-item-detail-white">
          <div class="city-item-text in-section" @click.passive="onCityClick(city.cityId, city.name)">
            {{ city.name }}
          </div>
        </li>
      </mt-index-section>
    </mt-index-list>

    <div class="city-search-result" v-show="isShowSearchResult">
      <div v-if="resultList.length == 0 || searchInput == ''" class="empty-result">
        <img src="../../../image/city/rectangle@2x.png" alt="" />
        <p>没有找到匹配的城市</p>
      </div>
      <div v-else class="city-search-result-list">
        <ul>
          <li v-for="city in resultList" :key="city.cityId" @click.passive="onCityClick(city.cityId, city.name)">
            {{ city.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Toast, IndexList, IndexSection, MessageBox } from 'mint-ui'
import Icon from '../../components/icon'
import _ from 'underscore'
import cookie from '../../lib/cookie'
import CONSTANT from '../../constant/city'
import CCONSTANT from '../../constant/cookie'

const testCzReg = /^[\u4e00-\u9fa5]+$/i
const testEnRge = /^[a-zA-Z]+$/

export default {
  data() {
    return {
      isShowLetterTip: false,
      isFocus: false,
      showCleanBtn: false,
      isShowSearchResult: false,
      searchInput: '',
      resultList: [],
      fromRoute: '',
      fromHref: '',
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$store.dispatch('getCityList').catch(e => {
      Toast({
        message: e,
        position: 'bottom',
        duration: 3000,
      })
    })
    this.$store.dispatch('getLocate', true).catch(e => {
      // this.gpsCity.name = '定位失败'
    })
  },
  created() {
    // this.selected = JSON.parse(cookie(CITYCONSTANT.MOVIE_LOCAL_CITY)) || {cityId: 0, name: ''}
  },
  components: {
    Icon,
    [IndexList.name]: IndexList,
    [IndexSection.name]: IndexSection,
  },
  methods: {
    showCancelBtn: function() {
      this.isFocus = true
      this.showCleanBtn = this.searchInput == '' ? false : true
    },
    hideCancelBtn: function() {
      this.isFocus = false
      this.showCleanBtn = false
      this.isShowSearchResult = false
    },
    getFirstLetterInWord: function(word) {
      return (word || '').charAt(0).toUpperCase()
    },
    onCityClick(id, name) {
      // change city state.
      this.$store.commit(CONSTANT.CITY_CHANGE_SELECTED, {
        cityId: id,
        name: name,
      })

      cookie(CCONSTANT.COOKIE_BUSINESS_CITY, id)
      // cookie(CCONSTANT.COOKIE_CITY_NAME, name)
      this.onHomeClick()
    },
    searchCity() {
      this.showCleanBtn = this.searchInput == '' ? false : true
      this.isShowSearchResult = true
      this.resultList = []
      if (!testCzReg.test(this.searchInput) && !testEnRge.test(this.searchInput)) {
        this.resultList = []
      } else if (testCzReg.test(this.searchInput)) {
        //匹配中文
        const reg = new RegExp('^.*' + this.searchInput + '.*$')
        this.allCity.map(city => {
          if (reg.test(city.name)) {
            this.resultList.push(city)
          }
        })
      } else if (testEnRge.test(this.searchInput)) {
        //匹配拼音和拼音缩写
        const reg = new RegExp('^.*' + this.searchInput.toLowerCase() + '.*$')
        this.allCity.map(city => {
          let py = city.pinyin.toLowerCase()
          if (reg.test(py) || reg.test(city.forShort)) {
            this.resultList.push(city)
          }
        })
      }
      // console.log(this.resultList)
    },
    cleanInput() {
      this.searchInput = ''
      this.showCleanBtn = false
    },
    getForShort(text) {
      let arr = text.split('')
      let res = ''
      for (let letter of arr) {
        if (letter === letter.toUpperCase()) {
          res += letter
        }
      }
      return res.toLowerCase()
    },
    onHomeClick: function() {
      console.log(222)
      const id = cookie(CCONSTANT.COOKIE_CITY_ID)
      const name = cookie(CCONSTANT.COOKIE_CITY_NAME)
      if (!id || !name) {
        return MessageBox.alert('请选择一个城市')
      }
      // 可以获取当前来源路由
      if (document.referrer.indexOf(window.location.origin) == 0) {
        // 同源跳转
        return this.$router.go(-1)
      } else {
        // 非同源跳转
        return this.$router.push({ name: 'home' })
      }
      // if(this.fromRoute) {
      //   console.log(333)
      //   return this.$router.go(-1)
      // } else {
      //   window.history.back()
      // }
      // 首次进入web 或者刷新无法获取来源路由，匹配window.location.href来获取是否同源路由而重定向
      // if(this.fromHref.match(CCONSTANT.ORIGIN_HOST)) {
      // console.log(444)
      // return window.location.href = this.fromHref
      // }
      // 非同源路由默认返回首页
      // return this.$router.push({name: "home"})
    },
  },
  beforeRouteEnter(to, from, next) {
    const href = window.location.href
    // if(from.name != to.name) {
    next(vm => {
      vm.fromRoute = from.name
      vm.fromHref = href
    })
    // }
  },
  beforeRouteLeave(to, from, next) {
    const id = cookie(CCONSTANT.COOKIE_CITY_ID)
    const name = cookie(CCONSTANT.COOKIE_CITY_NAME)
    if (!id || !name) {
      MessageBox.alert('请选择一个城市')
      return next(false)
    }
    next()
  },
  computed: {
    ...mapGetters(['cityGetSelectedCity']),
    selected() {
      return this.cityGetSelectedCity
    },
    allCity() {
      const vm = this
      return this.$store.state.city.cityList.map(item => {
        return {
          cityId: item.cityId,
          name: item.name,
          pinyin: item.pinyin.toLowerCase(),
          forShort: vm.getForShort(item.pinyin),
        }
      })
    },
    cityList() {
      const vm = this
      let firstLetter = ''
      let citySortedList = {}
      let cityFirstLetter = []
      let citySortedArray = {}
      let list
      //排序
      _.each(this.$store.state.city.cityList, function(city) {
        firstLetter = vm.getFirstLetterInWord(city.pinyin)
        if (firstLetter) {
          if (!citySortedList[firstLetter]) {
            cityFirstLetter.push(firstLetter)
            citySortedList[firstLetter] = []
          }
          citySortedList[firstLetter].push(city)
        }
      })
      cityFirstLetter = _.sortBy(cityFirstLetter)
      _.each(cityFirstLetter, function(letter) {
        citySortedArray[letter] = citySortedList[letter]
      })
      return citySortedArray
    },
    hotCities() {
      let arr = []
      _.each(this.$store.state.city.cityList, function(city) {
        if (city.isHot) {
          arr.push(city)
        }
      })
      return arr
    },
    gpsCity() {
      return this.$store.state.city.locate
    },
  },
  watch: {},
}
</script>
<style lang="less">
@import '../../../../app/stylesheet/variable';
@battleshipGrey: rgb(121, 125, 130);
@silver: rgb(189, 192, 197);
@textBlack: rgb(25, 26, 27);
@backgroundGrey: rgb(244, 244, 244);

.city-list {
  background-color: #fff;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: @headerHeight;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 300;
    background-color: #ffffff;
    & > div {
      float: left;
      height: @headerHeight;
    }
    &::after {
      .setBottomLine();
    }
    i {
      display: block;
      font-size: 23px;
      color: @textBlack;
    }
    .left {
      width: 14%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > i {
        margin-left: 10px;
      }
    }
    .title {
      width: 72%;
      text-align: center;
      font-size: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: @textBlack;
      div {
        color: @textBlack;
      }
    }
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    &::before,
    &::after {
      content: '';
      display: table;
    }

    &::after {
      clear: both;
    }
  }
  .search-city-input {
    z-index: 2000;
    height: 49px;
    width: 100vw;
    padding: 9.5px 15px;
    background-color: @backgroundGrey;
    position: fixed;
    top: 44px;
    .cancel-btn {
      width: 43px;
      position: absolute;
      display: inline-block;
      text-align: right;
      font-size: 14px;
      line-height: 30px;
    }
    .input-wrap {
      background-color: #fff;
      position: relative;
      display: inline-block;
      border-radius: 3px;
      width: 100%;
      height: 30px;
      .search-icon {
        position: absolute;
        left: 7px;
        top: 0;
        line-height: 30px;
        font-size: 21px;
        color: #797d82;
      }
      .search-input {
        position: absolute;
        left: 33.5px;
        top: 0;
        height: 30px;
        width: calc(~'100% - 65px');
        border: 0;
        &::-webkit-input-placeholder {
          color: @silver;
        }
        &:-moz-placeholder {
          color: @silver;
        }
        &::-moz-placeholder {
          color: @silver;
        }
        &:-ms-input-placeholder {
          color: @silver;
        }
      }
      .clean-icon {
        position: absolute;
        right: 7px;
        top: 0;
        line-height: 30px;
        font-size: 21px;
        color: @silver;
      }
    }
    .onFocus {
      width: calc(~'100% - 43px');
    }
  }
  .recommend-city {
    background-color: #fff;
    padding-left: 15px;
    padding-top: 15px;
    .city-index-title {
      font-size: 13px;
      color: @battleshipGrey;
      margin-bottom: 10px;
    }
    .city-index-detail {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: wrap;
    }
  }
  .city-index-section {
    ul {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: wrap;
      padding: 0 0 0 20px;
      .city-item-detail-white {
        position: relative;
        box-sizing: border-box;
        height: 48px;
        width: 100%;
        // width: calc(~'(100vw - 33px)/3');
        // text-align: center;
        // float: left;
        .in-section {
          background-color: #fff;
          height: 100%;
          line-height: 48px;
          font-size: 14px;
        }
      }
      .city-item-detail-white {
        color: @textBlack;
        &::after {
          .setBottomLine();
        }
      }
    }
  }
  .city-item-detail {
    width: calc(~'(100vw - 33px)/3');
    text-align: center;
    padding-bottom: 15px;
    box-sizing: border-box;
    float: left;
    .city-item-text {
      height: 30px;
      background-color: @backgroundGrey;
      line-height: 30px;
      border-radius: 3px;
      box-sizing: border-box;
      margin: 0 7.5px;
      font-size: 14px;
      color: @textBlack;
    }
  }
  .city-index {
    padding-top: 94px;
    .city-index-title {
      font-size: 13px;
      color: @battleshipGrey;
      margin-bottom: 10px;
    }
    .city-index-detail {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: wrap;
    }
    :nth-child(3n-2) {
      &::after {
        .setBottomLine();
      }
    }
    .mint-indexlist-content {
      // margin-right: 0 !important;
      z-index: 3000;
      height: 100vh !important;
      .mint-indexsection-index {
        background-color: @backgroundGrey;
        color: @battleshipGrey;
        padding: 0 0 0 15px;
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
      }
    }
    .mint-indexlist-nav {
      border: 0;
      position: fixed;
      z-index: 1999;
      width: 17px;
      margin-top: 94px;
      .mint-indexlist-navitem {
        font-size: 11px;
        padding: 0 6px;
        color: @textBlack;
      }
    }
    .mint-indexlist-indicator {
      z-index: 3008;
    }
  }
  .city-search-result {
    z-index: 1999;
    position: fixed;
    top: 44px;
    left: 0;
    background-color: #fff;
    height: calc(~'100vh - 49px');
    width: 100vw;
    overflow-y: auto;
    .empty-result {
      position: absolute;
      top: 107px;
      width: 100%;
      text-align: center;
      img {
        width: 90px;
        margin: auto;
      }
      p {
        color: @silver;
        font-size: 14px;
        margin: 0;
      }
    }
    .city-search-result-list {
      ul {
        padding-left: 15px;
        padding-top: 49px;
      }
      li {
        height: 44px;
        position: relative;
        line-height: 44px;
        color: @textBlack;
        font-size: 13px;
        &::after {
          .setBottomLine();
        }
      }
    }
  }
}
</style>
